module.exports = {
  "country": "SI",
  "artist": "Zala Kralj & Gasper Santl",
  "song": "Sebi",
  "year": "2019",
  "place": "15",
  "spotify": "5g9mbYv5JL9AIa9lKw2EHJ"
};